

    /**
     * Returns the first argument provided to it.
     */
    function identity(val){
        return val;
    }

    module.exports = identity;





//////////////////
// WEBPACK FOOTER
// ./~/mout/function/identity.js
// module id = 385
// module chunks = 0 1 2